// extracted by mini-css-extract-plugin
export default {"title":"WrongRoute_title__o+mY1","container":"WrongRoute_container__HQxdv"};